<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-添加
    -->
  <el-dialog :title="getTitle" :visible.sync="dialogVisible" @close="dialogFormVisible"
             :close-on-click-modal="false"
             :close-on-press-escape="false" width="40%">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item :label="getParentLabel" :label-width="formLabelWidth" prop="parentId" v-if="form.level">
        <!--        <treeselect class="max-w460" v-model="form.parentId" :options="getTreeOptions" :normalizer="normalizer"-->
        <!--                    placeholder="请选择上级分类/作物"/>-->
        <span>{{ form.parentLabel }}</span>
      </el-form-item>
      <el-form-item :label="getNameLabel + '名称'" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off" style="width: 50%"></el-input>
      </el-form-item>

      <el-form-item :label="getNameLabel + '图片'" prop="imageId" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">选择图片</el-button>
          <div v-if="form.imageId!=''" class="img">
            <img :src="filePath" width="100" height="100"/>
          </div>
        </el-row>
      </el-form-item>

      <el-form-item :label="getNameLabel + '排序'" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" style="width: 50%" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </el-dialog>

</template>

<script>
import CropApi from '@/api/crop.js'
import Upload from '@/components/file/Upload'
// import Treeselect from '@riophae/vue-treeselect'
// import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    Upload,
    // Treeselect
  },
  data () {
    return {
      form: {
        parentId: '0',
        parentLabel: '',
        level: 0,
        levelType: 0,
        name: '',
        sort: 100,
        imageId: ''
      },
      formRules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: '排序不能为空'
        }, {
          type: 'number',
          message: '排序必须为数字'
        }]
      },
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /*是否上传图片*/
      isupload: false,
      filePath: '',
    }
  },
  props: ['open_add', 'addform'],
  computed: {
    getTitle () {
      let text = ''
      if (this.form.level === 0) {
        text = '添加分类'
      } else if (this.form.level === 1) {
        text = '添加作物'
      } else if (this.form.level === 2) {
        text = '添加防治对象'
      }
      return text
    },
    getParentLabel () {
      let text = ''
      if (this.form.level === 1) {
        text = '所属分类'
      } else if (this.form.level === 2) {
        text = '作物'
      }
      return text
    },
    getNameLabel () {
      let text = ''
      if (this.form.level === 0) {
        text = '分类'
      } else if (this.form.level === 1) {
        text = '作物'
      } else if (this.form.level === 2) {
        text = '防治对象'
      }
      return text
    }
  },
  created () {
    this.form.parentId = this.addform.model.parentId || 0
    this.form.parentLabel = this.addform.model.parentLabel || ''
    this.form.level = this.addform.model.level || 0
    this.form.levelType = this.addform.model.levelType || 0
    this.dialogVisible = this.open_add
  },
  methods: {
    normalizer (node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children
      }
    },
    /*添加用户*/
    addUser () {
      let self = this
      let params = self.form
      if (!(params.parentId || parseInt(params.parentId) === 0)) {
        params.supplierCategoryId = 0
      }
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true
          CropApi.cropAdd(params).then(data => {
            self.loading = false
            self.$message({
              message: '添加成功',
              type: 'success'
            })
            self.dialogFormVisible(true)
          }).catch(error => {
            self.loading = false
          })
        }
      })
    },

    /*关闭弹窗*/
    dialogFormVisible (e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        })
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        })
      }
    },
    /*上传*/
    openUpload (e) {
      this.type = e
      this.isupload = true
    },
    /*获取图片*/
    returnImgsFunc (e) {
      if (e != null && e.length > 0) {
        this.filePath = e[0].filePath
        this.form.imageId = e[0].fileId
      }
      this.isupload = false
    },

  }
}
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/crop/Add.vue